module.exports = __webpack_public_path__ + "img/lc5.09c64c9f.png";